import React from "react";
import { BackButton, ContinueButton, BlankButton } from "./QueButtons";
import { QuePrivacy } from "./QuePrivacy";
import { QueInfo } from "./QueTexts";
import { Info, ScrollArrow } from "../svg/other";

export function QueRadioOptions({
  children,
  back,
  next,
  three,
  checkBox,
  normal,
  error,
}) {
  return (
    <section className="que-radio-container">
      {three && <div className="que-option-three-grid">{children}</div>}
      {checkBox && (
        <>
          <div className="que-scroll">
            <span>Slide for more options.</span>
            <ScrollArrow />
          </div>
          <div className="que-option-check-grid">{children}</div>
        </>
      )}
      {normal && <div className="que-option-grid">{children}</div>}
      <div className="que-options-navigation">
        {error ? (
          <div className="que-error-container">
            <QueInfo>
              <Info />
              You have to select at least one answer to continue.
            </QueInfo>
          </div>
        ) : null}
        <div className="que-button-container">
          {!back ? <BlankButton /> : <BackButton to={back} />}
          <ContinueButton to={next} />
        </div>
      </div>
      <QuePrivacy />
    </section>
  );
}

export function QueFormContainer({ children }) {
  return (
    <section className="que-radio-container">
      <div className="que-form-grid">{children}</div>
      <QuePrivacy />
    </section>
  );
}
